import { useMemo } from "react";

/**
 * Custom hook to process segment information from campaigns
 * @param {Object|Array} campaigns - Single campaign object or array of campaign objects
 * @returns {Object} Processed segment information
 */
export const useSegmentProcessor = (campaigns) => {
  return useMemo(() => {
    // Handle single campaign
    if (!Array.isArray(campaigns)) {
      const campaign = campaigns;
      if (!campaign?.segmentOptions?.length) {
        return {
          displaySegment: "-",
          totalPopulation: "-",
        };
      }

      const displaySegment = campaign.segmentOptions
        .map((segment) => segment.displayText)
        .filter(Boolean)
        .join(", ");

      const totalPopulation = campaign.segmentOptions.reduce((total, segment) => {
        const population = parseInt(segment.population, 10);
        return isNaN(population) ? total : total + population;
      }, 0);

      const processedData = {
        displaySegment: displaySegment || "-",
        totalPopulation:
          totalPopulation > 0 ? totalPopulation.toLocaleString("en-US") : "-",
      };
      return processedData;
    }

    // Handle array of campaigns
    const processedData = campaigns.reduce((acc, campaign) => {
      if (!campaign?.segmentOptions?.length) {
        acc[campaign.id] = {
          displaySegment: "-",
          totalPopulation: "-",
        };
        return acc;
      }

      const displaySegment = campaign.segmentOptions
        .map((segment) => segment.displayText)
        .filter(Boolean)
        .join(", ");

      const totalPopulation = campaign.segmentOptions.reduce((total, segment) => {
        const population = parseInt(segment.population, 10);
        return isNaN(population) ? total : total + population;
      }, 0);

      acc[campaign.id] = {
        displaySegment: displaySegment || "-",
        totalPopulation:
          totalPopulation > 0 ? totalPopulation.toLocaleString("en-US") : "-",
      };
      return acc;
    }, {});

    return processedData;
  }, [campaigns]);
};
